import CompaniesHero from './CompaniesHero';

export default CompaniesHero;
